import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { Contact } from '@/models/contact.model';
import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactFields',
  props: {
  modelValue: {
    type: Object as PropType<Contact>,
    required: true,
  },
  label: {
    type: String,
  },
  removable: {
    type: Boolean,
  },
  disabled: {
    type: Boolean,
  },
},
  emits: ['update:modelValue', 'change', 'remove'],
  setup(__props, { emit: __emit }) {

const props = __props;

const contact = ref<Contact>({ ...props.modelValue });

const emit = __emit;

function update() {
  emit('update:modelValue', contact.value);
  emit('change', contact.value);
}

function remove() {
  emit('remove');
}

const languageOptions = [
  {
    title: 'NL',
    value: 'nl',
  },
  {
    title: 'EN',
    value: 'en',
  },
];

watch(
  () => props.modelValue,
  () => {
    contact.value = { ...props.modelValue };
  },
);

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.label)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          dense: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, _toDisplayString(__props.label), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, { dense: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: contact.value.firstName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contact.value.firstName) = $event)),
              onChange: update,
              label: _ctx.$t('initiative.edit.firstname'),
              density: "compact",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: contact.value.lastName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contact.value.lastName) = $event)),
              onChange: update,
              label: _ctx.$t('initiative.edit.lastname'),
              density: "compact",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: contact.value.email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contact.value.email) = $event)),
              onChange: update,
              label: _ctx.$t('initiative.edit.email'),
              density: "compact",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: contact.value.main,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contact.value.main) = $event)),
              onChange: update,
              label: _ctx.$t('initiative.edit.main'),
              density: "compact",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { dense: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "5" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: contact.value.url,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((contact.value.url) = $event)),
              onChange: update,
              label: _ctx.$t('initiative.edit.url'),
              density: "compact",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: contact.value.phone,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((contact.value.phone) = $event)),
              onChange: update,
              label: _ctx.$t('initiative.edit.phone'),
              density: "compact",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              label: _ctx.$t('initiative.edit.language'),
              density: "compact",
              modelValue: contact.value.language,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((contact.value.language) = $event)),
              disabled: __props.disabled,
              items: languageOptions
            }, null, 8, ["label", "modelValue", "disabled"])
          ]),
          _: 1
        }),
        (__props.removable)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "1"
            }, {
              default: _withCtx(() => [
                (!__props.disabled)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      icon: "mdi-delete-outline",
                      class: "remove-button mt-2",
                      density: "compact",
                      onClick: _withModifiers(remove, ["prevent"])
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})